<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">大厅配置</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="main">
            <div class="main_content">
                <div v-for="item of data1" :key="item.id" class="main_content_li" @click="ChinaClick(item.id)"><div class="">{{item.name}}</div><i class="el-icon-arrow-right"></i></div>
            </div>
            <div class="main_content" v-if="data2.length != 0">
                <div class="main_content_li" v-for="(item , index) of data2" :key="index" @click="provinceClick(item.id)">
                    <div class="main_content_li_name">{{ item.name }}</div>
                    <div class="main_content_li_system" v-if="item.game == undefined " @click.stop="systemClick(item , 1)">设置</div>
                    <div class="main_content_li_system_sl" v-if="item.game != undefined " @click.stop="systemClick(item , 1)">已设置</div>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div class="main_content" v-if="data3.length != 0">
                <div class="main_content_li" v-for="(item , index) of data3" :key="index" @click="cityClick(item.id)">
                    <div class="main_content_li_name">{{ item.name }}</div>
                    <div class="main_content_li_system" v-if="item.game == undefined" @click.stop="systemClick(item , 2)">设置</div>
                    <div class="main_content_li_system_sl" v-if="item.game != undefined " @click.stop="systemClick(item , 2)">已设置</div>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div class="main_content" v-if="data4.length != 0">
                <div class="main_content_li" v-for="(item , index) of data4" :key="index" @click="theCityProperClcik(item.id)">
                    <div class="main_content_li_name">{{ item.name }}</div>
                    <div class="main_content_li_system" v-if="item.game == undefined" @click.stop="systemClick(item , 3)">设置</div>
                    <div class="main_content_li_system_sl" v-if="item.game != undefined " @click.stop="systemClick(item , 3)">已设置</div>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
            <div class="main_content" v-if="data5.length != 0">
                <div class="main_content_li" v-for="(item , index) of data5" :key="index" >
                    <div class="main_content_li_name">{{ item.name }}</div>
                    <div class="main_content_li_system" v-if="item.game == undefined" @click.stop="systemClick(item , 4)">设置</div>
                    <div class="main_content_li_system_sl" v-if="item.game != undefined" @click.stop="systemClick(item , 4)">已设置</div>
                    <i class="el-icon-arrow-right"></i>
                </div>
            </div>
        </div>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="25%" @click="editFormVisible = false">
            <el-form label-width="80px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="选择包：" prop="deptNo">
                    <el-select size="small" v-model="code" placeholder="请选择">
                        <el-option selected v-for="(item , index) in gameCode" :key="index" :label="item.comment + `(${item.name})`" :value="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editFormVisible = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="systemSubmit()">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getAreaList , machineGamecode , addrgame , addrgameSelect , addrgameUpdate} from '../../api/userMG'

export default {
    data(){
        return{
            editFormVisible:false,
            editForm:{},
            data1:[],
            data2:[],
            data3:[],
            data4:[],
            data5:[],
            gameCode:[],
            code:'',
            systemForm:{},
            SelectList:[]
        }
    },
    mounted(){
        this.addrgameSelect()
        this.machineGamecode()
        this.getAreaList()
    },
    methods:{
        addrgameSelect(){
            addrgameSelect().then(res=>{
                this.SelectList = res.data
            })
        },
        systemSubmit(){
            if(this.code == ''){
                this.$message.error('请选择标识')
            }else {
                if(this.systemForm.game == undefined){
                    addrgame({
                        addrid:this.systemForm.id,
                        addrname:this.systemForm.name,
                        gamecode:this.code,
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('设置成功')
                            addrgameSelect().then(res=>{
                                this.SelectList = res.data
                                this.editFormVisible = false
                                if(this.type == 1){
                                    this.ChinaClick(this.systemForm.pid)
                                }else if(this.type == 2){
                                    this.provinceClick(this.systemForm.pid)
                                }else if(this.type == 3){
                                    this.cityClick(this.systemForm.pid)
                                }else if(this.type == 4){
                                    this.theCityProperClcik(this.systemForm.pid)
                                }
                            })
                        }
                    })
                }else {
                    addrgameUpdate({
                        addrid:this.systemForm.id,
                        gamecode:this.code,
                    }).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            addrgameSelect().then(res=>{
                                this.SelectList = res.data
                                this.editFormVisible = false
                                if(this.type == 1){
                                    this.ChinaClick(this.systemForm.pid)
                                }else if(this.type == 2){
                                    this.provinceClick(this.systemForm.pid)
                                }else if(this.type == 3){
                                    this.cityClick(this.systemForm.pid)
                                }else if(this.type == 4){
                                    this.theCityProperClcik(this.systemForm.pid)
                                }
                            })
                        }
                    })
                }
            }
        },
        machineGamecode(){
            machineGamecode().then(res=>{
                this.gameCode = res.data
            })
        },
        theCityProperClcik(id){
            getAreaList({
                pid:id
            }).then(res=>{
                for(let item of this.SelectList){
                    for(let items of res.areaList){
                        if(items.id == item.addrid){
                            items.game = item.gamecode
                        }
                    }
                }
                this.data5 = res.areaList
            })
        },
        cityClick(id){
            getAreaList({
                pid:id
            }).then(res=>{
                for(let item of this.SelectList){
                    for(let items of res.areaList){
                        if(items.id == item.addrid){
                            items.game = item.gamecode
                        }
                    }
                }
                this.data4 = res.areaList
                this.data5 = []
            })
        },
        provinceClick(id){
            getAreaList({
                pid:id
            }).then(res=>{
                for(let item of this.SelectList){
                    for(let items of res.areaList){
                        if(items.id == item.addrid){
                            items.game = item.gamecode
                        }
                    }
                }
                this.data3 = res.areaList
                this.data4 = []
                this.data5 = []
            })
        },
        ChinaClick(id){
            getAreaList({
                pid:id
            }).then(res=>{
                for(let item of this.SelectList){
                    for(let items of res.areaList){
                        if(items.id == item.addrid){
                            items.game = item.gamecode
                        }
                    }
                }
                this.data2 = res.areaList
                this.data3 = []
                this.data4 = []
                this.data5 = []
            })
        },
        getAreaList(){
            getAreaList({
                pid:'-1'
            }).then(res=>{
                this.data1 = res.areaList
            })
        },
        liClick(){
            console.log(1324564654)
        },
        systemClick(e , type){
            console.log(e)
            this.systemForm = e
            this.code = e.game == undefined?'':e.game
            this.type = type
            this.editFormVisible = true
        },  

    }
}
</script>
<style scoped>

.main{
    width: 100%;
    height: 600px;
    display: flex;
}
.main_content{
    width: 200px ;
    height: 100%;
    overflow: auto;
    border:1px solid #888;
    margin-right: 20px;
}

::-webkit-scrollbar {
  width: 0px;
}
 
::-webkit-scrollbar-track {
  background-color: none;
}
 
::-webkit-scrollbar-thumb {
  background-color: none;
}
 
::-webkit-scrollbar-thumb:hover {
  background-color: none;
}
 
::-webkit-scrollbar-thumb:active {
  background-color: none;
}
.main_content_li{
    padding: 0 10px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.main_content_li_name{
    width: 100px;
}
.main_content_li_system{
    width: 40px;
    height: 20px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    background:  #6caae7;
    color: #fff;
}
.main_content_li_system_sl{
    width: 40px;
    height: 20px;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    background: #646262;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/views/system/hallConfiguration.vue